import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { SvgIconProps } from './SvgIcon.types';

export const JunkTruckIcon = memo(({ className, fontSize = 24 }: SvgIconProps) => {
  return (
    <SvgIcon
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ fill: 'none', fontSize }}
    >
      <g clipPath="url(#clip0_7153_24474)">
        <path
          d="M38.9775 15.125H31.955V21.1966C31.955 18.9169 30.4085 17.0725 28.4954 17.0725H25.0357H10.3262C9.35249 17.0725 8.4131 17.588 7.78302 18.4816L4.15149 23.6024V31.9767C4.15149 34.2564 5.69804 36.1008 7.61118 36.1008H9.34103H9.42122C9.77635 38.1285 11.5291 39.6636 13.6714 39.6636C15.8136 39.6636 17.5664 38.14 17.9215 36.1008H18.0934H28.5755H28.6557C29.0109 38.1285 30.7636 39.6636 32.9059 39.6636C35.0482 39.6636 36.8009 38.14 37.156 36.1008H43.9723C45.0263 36.1008 45.9886 35.2302 45.9886 34.0846V22.1475C46 18.2983 42.9184 15.125 38.9775 15.125Z"
          fill="#F0CBA7"
        />
        <path
          d="M25.7574 15.3197H16.501C16.1459 15.3197 15.8481 15.0562 15.7908 14.7125L15.5617 13.2118C15.5387 13.0514 15.5731 12.8795 15.6533 12.7421L18.1965 8.34298C18.3913 7.99931 18.8266 7.88475 19.1703 8.0795L27.0405 12.5931C27.2123 12.6962 27.3384 12.8681 27.3842 13.0628C27.43 13.2576 27.3842 13.4638 27.2582 13.6356L26.5479 14.6094C26.525 14.7469 26.4563 14.8729 26.3646 14.9645C26.2386 15.1822 26.0095 15.3197 25.7574 15.3197ZM17.1197 13.8877H25.3107L25.6429 13.4409L19.0901 9.68333L17.028 13.2461L17.1197 13.8877Z"
          fill="#226937"
        />
        <path
          d="M16.2719 13.0971L15.5731 8.70947L5.97302 10.0956L6.55728 14.5978H15.4585L16.2719 13.0971Z"
          fill="white"
        />
        <path
          d="M15.4585 15.3196H6.55728C6.19069 15.3196 5.89283 15.0561 5.84701 14.6895L5.27421 10.1759C5.22839 9.78638 5.49187 9.43124 5.88138 9.37397L15.4815 7.9878C15.8595 7.93052 16.2261 8.194 16.2948 8.58351L16.9936 12.9826C17.0165 13.143 16.9936 13.2919 16.9134 13.4294L16.1001 14.9301C15.9626 15.1707 15.722 15.3196 15.4585 15.3196ZM7.18735 13.8876H15.0347L15.5273 12.9711L14.9774 9.51144L6.77494 10.7029L7.18735 13.8876Z"
          fill="#226937"
        />
        <path
          d="M7.06129 34.348H5.33144C3.0288 34.348 1.15002 32.1714 1.15002 29.5021V21.1278C1.15002 20.9789 1.19585 20.83 1.2875 20.7154L4.91903 15.5946C5.68658 14.5063 6.83217 13.8877 8.0465 13.8877H26.2156C28.5183 13.8877 30.397 16.0643 30.397 18.7336V27.4401C30.397 27.841 30.0763 28.1503 29.6868 28.1503C29.2973 28.1503 28.9765 27.8296 28.9765 27.4401V18.7336C28.9765 16.8548 27.7393 15.3197 26.2271 15.3197H8.03504C7.29041 15.3197 6.58014 15.7206 6.07608 16.4195L2.58202 21.357V29.5021C2.58202 31.3809 3.81926 32.916 5.33144 32.916H7.06129C7.45079 32.916 7.77156 33.2368 7.77156 33.6263C7.77156 34.0158 7.45079 34.348 7.06129 34.348Z"
          fill="#EA7200"
        />
        <path
          d="M41.6926 34.3478H34.8649C34.4754 34.3478 34.1546 34.027 34.1546 33.6375C34.1546 33.248 34.4754 32.9272 34.8649 32.9272H41.6926C42.3227 32.9272 42.9986 32.4002 42.9986 31.6212V22.8804H29.6639C29.2744 22.8804 28.9536 22.5596 28.9536 22.1701V12.6617C28.9536 12.2607 29.2744 11.9399 29.6639 11.9399H36.6864C40.948 11.9399 44.4191 15.4111 44.4191 19.6727V31.5983C44.4306 33.122 43.2048 34.3478 41.6926 34.3478ZM30.3856 21.4369H42.9986V19.6727C42.9986 16.1901 40.169 13.3719 36.6978 13.3719H30.3971V21.4369H30.3856Z"
          fill="#EA7200"
        />
        <path
          d="M30.6262 37.9108C27.8424 37.9108 25.5856 35.6425 25.5856 32.8702C25.5856 30.0979 27.8538 27.8296 30.6262 27.8296C33.41 27.8296 35.6668 30.0979 35.6668 32.8702C35.6668 35.6425 33.41 37.9108 30.6262 37.9108ZM30.6262 29.2501C28.5985 29.2501 27.0176 30.8425 27.0176 32.8587C27.0176 34.875 28.5985 36.4674 30.6262 36.4674C32.6539 36.4674 34.2348 34.875 34.2348 32.8587C34.2348 30.8425 32.6539 29.2501 30.6262 29.2501Z"
          fill="#EA7200"
        />
        <path
          d="M11.3917 37.9108C8.60789 37.9108 6.35107 35.6425 6.35107 32.8702C6.35107 30.0979 8.61935 27.8296 11.3917 27.8296C14.1755 27.8296 16.4323 30.0979 16.4323 32.8702C16.4323 35.6425 14.1755 37.9108 11.3917 37.9108ZM11.3917 29.2501C9.36399 29.2501 7.78307 30.8425 7.78307 32.8587C7.78307 34.875 9.36399 36.4674 11.3917 36.4674C13.4194 36.4674 15.0003 34.875 15.0003 32.8587C15.0003 30.8425 13.4194 29.2501 11.3917 29.2501Z"
          fill="#EA7200"
        />
        <path
          d="M26.2958 34.3478H15.8137C15.4242 34.3478 15.1034 34.027 15.1034 33.6375C15.1034 33.248 15.4242 32.9272 15.8137 32.9272H26.2958C26.6853 32.9272 27.0061 33.248 27.0061 33.6375C27.0061 34.027 26.6968 34.3478 26.2958 34.3478Z"
          fill="#EA7200"
        />
        <path
          d="M23.7641 25.6758C23.3746 25.6758 23.0538 25.355 23.0538 24.9655V18.9168C23.0538 18.5159 23.3746 18.2065 23.7641 18.2065C24.1536 18.2065 24.4744 18.5273 24.4744 18.9168V24.9655C24.4858 25.355 24.1651 25.6758 23.7641 25.6758Z"
          fill="#226937"
        />
        <path
          d="M17.4404 25.6758C17.0509 25.6758 16.7301 25.355 16.7301 24.9655V18.9168C16.7301 18.5159 17.0509 18.2065 17.4404 18.2065C17.8299 18.2065 18.1506 18.5273 18.1506 18.9168V24.9655C18.1621 25.355 17.8413 25.6758 17.4404 25.6758Z"
          fill="#226937"
        />
        <path
          d="M11.1281 25.6758C10.7386 25.6758 10.4178 25.355 10.4178 24.9655V18.9168C10.4178 18.5159 10.7386 18.2065 11.1281 18.2065C11.5176 18.2065 11.8384 18.5273 11.8384 18.9168V24.9655C11.8384 25.355 11.5176 25.6758 11.1281 25.6758Z"
          fill="#226937"
        />
      </g>
      <defs>
        <clipPath id="clip0_7153_24474">
          <rect width="44.85" height="31.6642" fill="white" transform="translate(1.15002 7.98779)" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
});
